import React from 'react';

const EMAIL_CONTATO = 'rafaelcomerciodigital4@gmail.com';

function Privacidade() {
    return (
        <div style={{ minHeight: '100vh', background: '#fff' }}>
        <div style={{ maxWidth: 820, margin: '0 auto', padding: '32px 20px', fontFamily: 'Arial, sans-serif', lineHeight: 1.7, color: '#333' }}>
            <h1 style={{ color: '#222' }}>Política de Privacidade — S6 Gestão</h1>
            <p><strong>Última atualização:</strong> 04/10/2026</p>

            <h3>1. Introdução</h3>
            <p>Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos os dados pessoais
                dos usuários do sistema S6 Gestão, em conformidade com a <strong>Lei Geral de Proteção de Dados
                (LGPD — Lei nº 13.709/2018)</strong>.</p>

            <h3>2. Dados coletados</h3>
            <ul>
                <li><strong>Dados de identificação:</strong> nome completo, CPF/CNPJ, e-mail, telefone e endereço.</li>
                <li><strong>Dados de acesso:</strong> login e senha (armazenada de forma criptografada).</li>
                <li><strong>Dados de navegação:</strong> endereço IP, cookies essenciais e informações do navegador.</li>
            </ul>
            <p><strong>Não armazenamos dados de cartão de crédito.</strong> Os pagamentos são processados diretamente
                pelo <strong>Stripe</strong>, certificado PCI-DSS.</p>

            <h3>3. Finalidade do tratamento</h3>
            <ul>
                <li>Criação e gerenciamento da sua conta;</li>
                <li>Processamento de assinaturas e pagamentos;</li>
                <li>Comunicação sobre o serviço (notificações e suporte);</li>
                <li>Cumprimento de obrigações legais e regulatórias;</li>
                <li>Melhoria contínua do serviço.</li>
            </ul>

            <h3>4. Base legal (LGPD)</h3>
            <ul>
                <li><strong>Execução de contrato</strong> (Art. 7º, V): para fornecer o serviço contratado;</li>
                <li><strong>Consentimento</strong> (Art. 7º, I): para comunicações opcionais;</li>
                <li><strong>Obrigação legal</strong> (Art. 7º, II): para obrigações fiscais;</li>
                <li><strong>Legítimo interesse</strong> (Art. 7º, IX): para melhoria e segurança do serviço.</li>
            </ul>

            <h3>5. Compartilhamento de dados</h3>
            <ul>
                <li><strong>Stripe:</strong> processamento de pagamentos;</li>
                <li><strong>Provedores de infraestrutura e nuvem:</strong> hospedagem do sistema e armazenamento de cópias de segurança.</li>
            </ul>
            <p>Não vendemos, alugamos nem compartilhamos seus dados com terceiros para fins de marketing.</p>

            <h3>6. Retenção de dados</h3>
            <p>Seus dados são mantidos durante a vigência da sua conta e pelo período necessário para cumprir obrigações
                legais. Após o cancelamento, os dados são removidos ou anonimizados em até 30 dias, salvo obrigação legal
                em contrário.</p>

            <h3>7. Seus direitos (LGPD)</h3>
            <ul>
                <li>Confirmar a existência de tratamento dos seus dados;</li>
                <li>Acessar seus dados pessoais;</li>
                <li>Corrigir dados incompletos, inexatos ou desatualizados;</li>
                <li>Solicitar anonimização, bloqueio ou eliminação de dados desnecessários;</li>
                <li>Solicitar a portabilidade dos seus dados;</li>
                <li>Revogar o consentimento a qualquer momento;</li>
                <li>Solicitar informações sobre o compartilhamento de dados.</li>
            </ul>

            <h3>8. Segurança</h3>
            <ul>
                <li>Conexão criptografada (HTTPS/TLS);</li>
                <li>Senhas armazenadas com hash criptográfico;</li>
                <li>Acesso restrito a dados pessoais;</li>
                <li>Cópias de segurança regulares e monitoramento.</li>
            </ul>

            <h3>9. Cookies</h3>
            <p>Utilizamos apenas cookies essenciais para o funcionamento do site, como autenticação e preferências.</p>

            <h3>10. Contato</h3>
            <p>Para exercer seus direitos ou tirar dúvidas sobre esta política, escreva para{' '}
                <a href={`mailto:${EMAIL_CONTATO}`}>{EMAIL_CONTATO}</a>.</p>

            <h3>11. Alterações</h3>
            <p>Esta política pode ser atualizada periodicamente. A versão vigente estará sempre disponível nesta página.</p>
        </div>
        </div>
    );
}

export default Privacidade;
